import {
  Wrap,
  Center,
  Flex,
  Spacer,
  Stack,
  Box,
  HStack,
  Input,
  Button,
} from '@chakra-ui/react';
import { useEffect, useState, useRef } from 'react';
import { cans } from '../icblast.js';

import { transformData } from '../util.js';
import { Rating } from './Rating.js';
import { UserBanner } from './User.js';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { ServiceCard } from './ServiceCard.js';

export function TopServices() {
  let [topServices, setTopServices] = useState([]);
  let [searchText, setSearchText] = useState(false);

  useEffect(() => {
    setTopServices([]);
    (async () => {
      if (searchText) {
        console.log(searchText);

        setTopServices(await cans.qgig.search_services(searchText));
      } else {
        setTopServices(await cans.qgig.get_top_services());
      }
    })();
  }, [searchText]);

  return (
    <Center>
      <Stack>
        <SearchBox onSearch={setSearchText} />
        {topServices.length ? (
          <Wrap justify="center">
            {topServices.map((x, idx) => (
              <ServiceCard key={idx} {...x} />
            ))}
          </Wrap>
        ) : null}
      </Stack>
    </Center>
  );
}

function SearchBox({ onSearch }) {
  const inputEl = useRef(null);
  return (
    <Box w="500px" m="auto">
      <form
        style={{ display: 'inline' }}
        action="#"
        onSubmit={e => {
          e.preventDefault();
          onSearch(inputEl.current.value);
          // console.log('gg', inputEl.current.value);
        }}
      >
        <HStack>
          <Input ref={inputEl} placeholder="illustration and web" />
          <Button type="submit">Search</Button>
        </HStack>
      </form>
    </Box>
  );
}
